var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.44531C0 6.68164 0.107422 6.90723 0.300781 7.08984L5.84375 12.6221C6.03711 12.8047 6.25195 12.8906 6.47754 12.8906C6.9502 12.8906 7.31543 12.5361 7.31543 12.0527C7.31543 11.8271 7.24023 11.6016 7.0791 11.4512L5.59668 9.91504L1.96582 6.64941L1.77246 7.11133L4.62988 7.31543H14.7705C15.2754 7.31543 15.6299 6.9502 15.6299 6.44531C15.6299 5.94043 15.2754 5.5752 14.7705 5.5752H4.62988L1.77246 5.7793L1.96582 6.25195L5.59668 2.97559L7.0791 1.43945C7.24023 1.28906 7.31543 1.06348 7.31543 0.837891C7.31543 0.354492 6.9502 0 6.47754 0C6.25195 0 6.03711 0.0859375 5.84375 0.268555L0.300781 5.80078C0.107422 5.9834 0 6.20898 0 6.44531Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.12b0eee1edc15fe84921324ff75327b3.svg";
export { ForwardRef as ReactComponent };